import formatArticleName from "./formatArticleName";

// Week-order page only (customer request, Tom 21/10/2026): every hyphen in an
// article name is shown as an underscore, so "202509-630" reads "202509_630".
//
// Deliberately a separate helper and not part of `formatArticleName`: that one
// also feeds the basket, the checkout and the shop's order view, and those have
// to keep showing the name as it is. Presentation only — the stored
// `article_name` stays exactly what the backend sent, and the WoodWing lookup
// keeps using the raw name (that is the file name in WoodWing).
export default function formatWeekOrderArticleName(
  articleName?: string | null
): string {
  return formatArticleName(articleName).replace(/-/g, "_");
}
